export default __webpack_public_path__ + "static/media/Step1.9c979113.png";